import React, { useState, useCallback, MouseEvent } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { SchoolsState } from '../../states/schools/reducer'
import { useAppSelector } from '../../hooks/useAppSelector'
import { useDropzone, FileWithPath } from 'react-dropzone'
import { SchoolLogo } from '../SchoolLogo'
import { STYLES } from '../../static/style'
import { Overlay } from '../../components/Overlay'
import { uploadSchoolLogo } from '../../states/schools/actions'
import { FileHelper } from '../../helpers/FileHelper'
import { CONFIG } from '../../config'
const StyledUploadImage = styled.div`
  position: relative;
  border: 1px solid ${STYLES.BORDER_COLOR};
  cursor: pointer;
`
const ImageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const OverlayMessage = styled(Overlay)`
  position: absolute;
  color: ${STYLES.COLOR_WHITE};
  font-size: ${STYLES.FONT_SIZE_MD};
`
const UploadImageContainer = styled.div``

export interface UploadUpdateLogoProps {
  value?: string
  onChange: (urlPath: string) => void
  className?: string
}

const UploadUpdateLogo: React.FC<UploadUpdateLogoProps> = ({
  value,
  onChange,
  className,
}) => {
  const dispatch = useDispatch()
  const [showOverlay, setShowOverlay] = useState<boolean>(false)

  const onDrop = useCallback((files: FileWithPath[]): void => {
    const file = files[0]
    const filePath = file.path
    const contentType = FileHelper.getContentType(filePath)
    dispatch(
      uploadSchoolLogo({
        file,
        contentType,
        success: ({ urlPath, preSignedUrl }) => {
          onChange(urlPath)
        },
      })
    )
  }, [])

  const overlay = {
    show: (): void => setShowOverlay(true),
    hide: (): void => setShowOverlay(false),
  }
  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
    accept: 'image/jpeg, image/png, image/svg, image/jpg, image/gif',
  })
  const handleOpen = (evt: MouseEvent<HTMLElement>) => {
    evt.stopPropagation()
    open()
  }
  return (
    <UploadImageContainer>
      <StyledUploadImage
        {...getRootProps()}
        className={className}
        onFocus={() => {}}
        onMouseOver={overlay.show}
        onMouseLeave={overlay.hide}
      >
        {showOverlay && (
          <OverlayMessage onClick={handleOpen}>
            Choose from Media Library
          </OverlayMessage>
        )}
        <ImageContainer>
          <input {...getInputProps()} />
          <SchoolLogo logo={value} size={140} />
        </ImageContainer>
      </StyledUploadImage>
    </UploadImageContainer>
  )
}

export default UploadUpdateLogo
